import React from 'react';
import PropTypes from 'prop-types';

function Panel({ icon, title, children }) {
  return (
    <div className="card p-4 mb-3">
      {title && title.length > 0 && (
        <h2 className="fs-2 fw-semibold mb-1">
          {icon && (
            <div
              className="d-inline-block card text-center align-top me-2"
              style={{
                height: '28px',
                width: '28px',
                lineHeight: '19px',
              }}
            >
              <i className={`fa fa-${icon}`} style={{ fontSize: '11px' }} />
            </div>
          )}
          {title}
        </h2>
      )}
      {children}
    </div>
  );
}

Panel.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string,
  children: PropTypes.node,
};

Panel.defaultProps = {
  icon: null,
  title: null,
  children: null,
};

export default Panel;
